export const cookie = {
    set: function (cookieName, cookieValue, cookieMinutes) {
        var date = new Date();
        var domain = window.location.host.split(".");
        domain = domain[domain.length - 2] + "." + domain[domain.length - 1];
        date.setTime(date.getTime() + cookieMinutes * 60 * 1000);
        var cookie = [
        cookieName + "=" + cookieValue,
        "domain=." + domain,
        "expires=" + date.toUTCString(),
        "path=/",
        ];
        document.cookie = cookie.join(";");
        return undefined;
    },
    get: function (cookieName) {
        var cookieParam = cookieName + "=";
        var cookieSplit = document.cookie.split(";");
        for (var i = 0; i < cookieSplit.length; i++) {
        var cookiePart = cookieSplit[i];
        while (cookiePart.charAt(0) == " ") {
            cookiePart = cookiePart.substring(1);
        }
        if (cookiePart.indexOf(cookieParam) == 0) {
            return cookiePart.substring(cookieParam.length, cookiePart.length);
        }
        }
        return undefined;
    }

}

export default cookie;